// project-imports
import { deleteRequest, getRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - PROPERTIES ||============================== //

export async function handleProperties(action: APIAction) {
  switch (action.method) {
    // case 'migrate':
    //   return getRequest('/properties/migrate?limit=' + action.data.limit + '&offset=' + action.data.offset);
    case 'migrate-plans':
      return getRequest('/properties/migrate-plans');
    case 'create':
      return postRequest('/properties', action.data);
    case 'read':
      return getRequest(`/properties/${action.id}`);
    case 'update':
      return putRequest(`/properties/${action.id}`, action.data);
    case 'delete':
      return deleteRequest(`/properties/${action.id}`);
    case 'duplicate':
      return postRequest(`/properties/${action.id}/duplicate`, action.data);
    case 'update-stage':
      return putRequest(`/properties/${action.id}/stage`, action.data);
    case 'read-files':
      return getRequest(`/properties/${action.id}/files`);
    default:
      console.info('[ApiManager > handleApiAction > handleProperties] - Unknown method');
      break;
  }
}
